module.exports = __webpack_public_path__ + "img/internal-documents_1.47a7fee3.svg";